import { InferValueTypes } from "../service-types";
import * as actions from "./actions";

export enum ContractAction {
  GET_CONTRACT_RECORD = "GET_CONTRACT_RECORD",
  CANCEL_CONTRACT = "CANCEL_CONTRACT",
  CANCEL_CONTRACT_AMOUNT_CLACULATE = "CANCEL_CONTRACT_AMOUNT_CLACULATE",
  SET_CONTRACT_RECORD = "SET_CONTRACT_RECORD",
  CLEAN_UP = "CONTRACT_STATE_CLEAN_UP",
  CLAIM_FILE_SEND_EMAIL = "CLAIM_FILE_SEND_EMAIL",
  SUBMIT_TICKET = "CONTRACT_SUBMIT_TICKET",
}

export interface ContractState {
  id: string;
  name: string;
  regDate: Date | null;
  deliveryDate: Date | null;
  expired: number;
  customerFirstName: string;
  customerLastName: string;
  customerId: string;
  customerPhone: string;
  customerAlternatePhone: string;
  customerEmail: string;
  customerAddress1: string;
  customerAddress2: string;
  customerCity: string;
  customerState: string;
  customerZip: string;
  deliveryAddress1: string;
  deliveryAddress2: string;
  deliveryCity: string;
  deliveryState: string;
  deliveryZip: string;
  storeName: string;
  salesPerson: string;
  storeAddress1: string;
  storeCity: string;
  storeState: string;
  storeZip: string;
  invoiceNumber: string;
  totalPrice: number;
  dealerSku: string;
  warrantyProgram: string;
  warrantyProgramPrice: number;
  purchaseDate: Date | null;
  expirationDate: Date | null;
  status: string | null;
  lineItems: LineItems[];
  calculatedRefundAmount?: number;
  isActiveClaim?: boolean;
  contactId: string;
  TCFileLink: string;
}

export interface LineItems {
  id: string;
  itemType: string;
  manufacturer: string;
  material: string;
  color: string;
  vendor: string;
  itemDescription: string;
  modelNumber: string;
  deliveryDate: Date | null;
  retailerPrice: number;
  quality: string;
  serialNumber: string;
}

export const ContractScope = "Contract";

export type ContractActionTypes = ReturnType<InferValueTypes<typeof actions>>;
